import React, { useState } from "react";
import axios from "axios";
import { toast } from 'react-toastify';

const useLogin = () => {

  const [loading, setLoading] = useState(false);
  const login = ({ email, password }) => {
    setLoading(true);
    axios.post("/users/sign_in", { email, password }).
      then((response) => {
        if (response.status === 200) {
          // Redirect to the dashboard
          window.location.href = "/";
        }
      }).
      catch((error) => {
        console.log(error);
      }).
      finally(() => {
        setLoading(false);
      });
  }

  //Logout 

  const logout = () => {
    setLoading(true)
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    axios.delete("/users/sign_out",
      {
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    ).
      then((response) => {
        //Redirect 
        // window.location = "/authors"
        if (response.status === 204) {
          window.location = "/"
        }
      }).catch((error) => {
        console.log("ERROR", error)
      })
  }


  const resetPassword = () => {
    setLoading(true)
    const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    axios.post("/users/reset_password",
      {
        headers: {
          "X-CSRF-Token": csrfToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        withCredentials: true,
      }
    ).
      then((response) => {
        toast.info("Reset Password Link Sent to your email")
      }).catch((error) => {
        console.log("ERROR", error)
      })
  }


  return { loading, login, logout, resetPassword };
}
export default useLogin;